import {EagGridStore} from '../store/createEagGridStore';
import {ActivePreset} from '../types/Api';
import {setSearchParamsByGridCode} from '../utils/url/setSearchParamsByGridCode';

/**
 * Syncs the URL search param to a preset's dataQueryId, then writes queryId +
 * activePreset ATOMICALLY (one store dispatch).
 *
 * Why queryId and activePreset must land together:
 *
 * - GridLifecycle.syncDirtyOrPutPreset() reactively computes isCustomPresetDirty()
 *   by comparing savedPreset.dataQueryId against state.queryId. If queryId were
 *   still stale when activePreset changes, the dirty check would read a
 *   false-positive and PresetButton would render a spurious leading "* ".
 *
 * - Conversely, setting queryId in its OWN dispatch first (the old two-step
 *   ordering) fired that same reaction while the PREVIOUS preset was still
 *   active: activating a custom preset from the virtual view ran the reaction's
 *   virtual branch with the custom's queryId already in the URL — and PUT the
 *   virtual preset with the custom preset's dataQueryId, permanently pointing
 *   the Default view at the custom preset's filters (T20-134468 filter leak).
 *
 * Used by the pre-async optimistic block of activation/deactivation
 * (see usePresetActivation).
 */
export function applyPresetQuerySync(
  store: EagGridStore,
  gridCode: string,
  dataQueryId: string,
  presetDetail: ActivePreset
): void {
  setSearchParamsByGridCode(gridCode, dataQueryId);
  store.applyActivePresetTransition(dataQueryId, presetDetail);
}
